import * as React from 'react';

import { TranslationContext } from '../TranslationContext';
import { CmsObjectWithDefault, Translation } from '@components/Cms/types';
import { allDefaultTranslations } from '@components/Cms';

export const useTranslation = <TCmsKey extends string>(
    cmsWithDefault: CmsObjectWithDefault<TCmsKey>
): Translation<TCmsKey> => {
    const store = React.useContext(TranslationContext);

    return Object.assign(
        {},
        ...Object.keys(cmsWithDefault).map(t => {
            const { cmsId } = cmsWithDefault[t as TCmsKey];
            return {
                [t]: store[cmsId] || allDefaultTranslations[cmsId],
            };
        })
    );
};
